<template>
  <div class="block">
    <img class="page-banner" src="../../static/img/product-banner.jpg">
    <div class="page-content">
      <div>
        <ul class="product-server">
          <li v-for="item in $t('products.servers')">
            <h3>{{item.title}}</h3>
            <p>{{item.subTitle}}</p>
          </li>
        </ul>
        <p>{{$t('products.servers')[0].desc}}<br><br></p>
        <p>{{$t('products.servers')[1].desc}}<br><br></p>
        <p>{{$t('products.servers')[2].desc}}<br><br></p>
      </div>
      <company></company>
    </div>
  </div>
</template>
<script type="text/javascript">
  import Company from '../components/Company/Company.vue'
	export default {
    components: {
      'company':Company
    },
    data () {
      return {
        
      }
    },
    methods: {

    },
    created(){

    }
  }
</script>
<style type="text/css">
  .product-server{
    width: 100%;
    float: left;
    margin-bottom: 50px;
  }
  .product-server li{
    width: 30%;
    float: left;
    margin-right: 5%;
    text-align: left;
    padding: 30px 50px;
    box-sizing: border-box;
    background-color: #eeeeee;
    height: 155px;
  }
  .product-server li:last-child{
    margin-right: 0;
  }
  .product-server li h3{
    font-size: 20px;
    margin-bottom: 15px;
  }
  .product-server li p{
    font-size: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/views/products.vue